import ClaimDetailScreen from '../components/ClaimDetailScreen';
import ConfirmationScreen from '../components/ConfirmationScreen';
import PaymentDetailScreen from '../components/PaymentDetailScreen';
import PolicyDetailScreen from '../components/PolicyDetailScreen';
import DocumentationScreen from '../components/Documentation/DocumentationScreen';
import SubmitterDetailScreen from '../components/SubmitterDetailScreen';
import UsersDetailScreen from '../components/UsersDetailScreen';

import { translations } from './consts';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: PolicyDetailScreen,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: ClaimDetailScreen,
        step: 1,
        label: translations.stepLabel.DETAILS,
    },
    {
        path: '/stepThree',
        screen: SubmitterDetailScreen,
        step: 2,
        label: translations.stepLabel.SUBMITTER,
    },
    {
        path: '/stepFour',
        screen: UsersDetailScreen,
        step: 3,
        label: translations.stepLabel.USER,
    },
    {
        path: '/stepFive',
        screen: PaymentDetailScreen,
        step: 4,
        label: translations.stepLabel.PAYMENT,
    },
    {
        path: '/stepSix',
        screen: DocumentationScreen,
        step: 5,
        label: translations.stepLabel.DOCUMENTATION,
    },
    {
        path: '/stepSeven',
        screen: ConfirmationScreen,
        step: 6,
        label: translations.stepLabel.CONFIRMATION,
    },
];

export default stepsComposer;
